import React, { useMemo, useState } from "react";
import moment from "moment";

const HorizontalTimeline = ({ verification = {}, visits = [] }) => {
  const [hoveredEvent, setHoveredEvent] = useState(null);

  const timelineEvents = useMemo(() => {
    const eventMap = {
      FechaCreacion: { label: "Creación", color: "#52c41a" },
      FechaListo: { label: "Listo", color: "#1890ff" },
      FechaEmision: { label: "Emisión", color: "#722ed1" },
      FechaPago: { label: "Pagado", color: "#52c41a" },
      FechaRevision: { label: "Revisión", color: "#fa8c16" },
      FechaPapeleria: { label: "Papelería", color: "#13c2c2" },
      FechaCancelacion: { label: "Cancelación", color: "#f5222d" },
      FechaRecepcion: { label: "Solicitud", color: "#eb2f96" },
      FechaContrato: { label: "Contrato", color: "#2f54eb" },
    };

    const verificationEvents = Object.entries(eventMap).map(([key, config]) => ({
      id: key,
      date: verification?.[key],
      hasDate: !!verification?.[key],
      ...config,
    }));

    const visitEvents = (visits || []).map((visit, index) => ({
      id: `visit-${visit.VisitaID || index}`,
      date: visit?.FechaVisita,
      hasDate: !!visit?.FechaVisita,
      label: `Visita ${index + 1}`,
      color: "#9254de",
    }));

    const allEvents = [...verificationEvents, ...visitEvents];

    return allEvents
      .filter(e => e.hasDate)
      .sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf());
  }, [verification, visits]);

  const formatDate = (dateString) => {
    if (!dateString) return null;
    return moment.utc(dateString).format("DD/MM/YYYY");
  };

  const getEventStyle = (event, index) => {
    const total = timelineEvents.length;
    const baseStyle = {
      position: "absolute",
      left: total > 1 ? `${(index / (total - 1)) * 100}%` : "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      cursor: "pointer",
      transition: "all 0.3s ease",
      zIndex: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    };

    if (total > 1) {
      if (index === 0) baseStyle.transform = "translate(0, -50%)";
      if (index === total - 1) baseStyle.transform = "translate(-100%, -50%)";
    }

    return baseStyle;
  };

  if (timelineEvents.length === 0) return null;

  return (
    <div style={{ position: "relative", width: "100%", padding: "2.5rem 1rem" }}>
      <div style={{ position: "relative", height: "24px" }}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: 0,
            width: "100%",
            height: "3px",
            background: "linear-gradient(90deg, #e8e8e8 0%, #d9d9d9 100%)",
            transform: "translateY(-50%)",
            borderRadius: "2px",
            zIndex: 1,
          }}
        />
        {timelineEvents.map((event, index) => (
          <div
            key={event.id}
            style={getEventStyle(event, index)}
            onMouseEnter={() => setHoveredEvent(event.id)}
            onMouseLeave={() => setHoveredEvent(null)}
          >
            <div style={{ fontSize: "11px", minWidth: "60px", fontWeight: "700", color: event.hasDate ? "#262626" : "#8c8c8c", marginBottom: "10px", textAlign: "center", textTransform: "uppercase", letterSpacing: "0.5px" }}>
              {event.label}
            </div>

            <div
              style={{
                width: event.hasDate ? "16px" : "12px",
                height: event.hasDate ? "16px" : "12px",
                backgroundColor: event.hasDate ? event.color : "#d9d9d9",
                borderRadius: "50%",
                boxShadow: `0 0 0 3px white, ${event.hasDate ? "0 2px 8px rgba(0,0,0,0.15)" : "0 1px 4px rgba(0,0,0,0.1)"}`,
                transform: hoveredEvent === event.id ? "scale(1.2)" : "scale(1)",
                transition: "all 0.2s ease",
                opacity: event.hasDate ? 1 : 0.6,
                background: event.hasDate ? event.color : `repeating-linear-gradient(45deg, #d9d9d9, #d9d9d9 2px, #f0f0f0 2px, #f0f0f0 4px)`,
              }}
            />

            <div style={{ fontSize: "10px", minWidth: "60px", color: event.hasDate ? "#595959" : "#bfbfbf", marginTop: "8px", textAlign: "center" }}>
              {event.hasDate ? formatDate(event.date) : "No asignado"}
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translate(-50%, 5px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
};

export default HorizontalTimeline;
